module.exports = __webpack_public_path__ + "static/mobDataManagement-dc3aa354b87e71a1a1a707311ce425b2.gif";